var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.796 14.928C14.7015 14.928 17.8675 11.762 17.8675 7.85658C17.8675 3.95114 14.7015 0.785156 10.796 0.785156C6.8906 0.785156 3.72461 3.95114 3.72461 7.85658C3.72461 11.762 6.8906 14.928 10.796 14.928Z",
    stroke: "#9B2C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7972 10.9986C12.5329 10.9986 13.94 9.5915 13.94 7.85575C13.94 6.12 12.5329 4.71289 10.7972 4.71289C9.0614 4.71289 7.6543 6.12 7.6543 7.85575C7.6543 9.5915 9.0614 10.9986 10.7972 10.9986Z",
    stroke: "#9B2C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42834 14.8017L8.04548 20.616C8.01811 20.7265 7.96752 20.8299 7.89707 20.9193C7.82662 21.0088 7.73793 21.0821 7.63691 21.1346C7.53028 21.1809 7.41529 21.2048 7.29905 21.2048C7.18282 21.2048 7.06782 21.1809 6.96119 21.1346L1.74405 18.856C1.63462 18.8043 1.53833 18.7284 1.4624 18.6342C1.38648 18.5399 1.3329 18.4296 1.30568 18.3117C1.27846 18.1937 1.27831 18.0712 1.30525 17.9532C1.33218 17.8351 1.3855 17.7248 1.46119 17.6303L5.49977 12.5703",
    stroke: "#9B2C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5703 14.7249L13.9846 20.6177C14.0127 20.7301 14.0653 20.8349 14.1387 20.9245C14.212 21.0142 14.3043 21.0865 14.4089 21.1363C14.5126 21.1832 14.6251 21.2074 14.7389 21.2074C14.8527 21.2074 14.9652 21.1832 15.0689 21.1363L20.2546 18.8577C20.3657 18.8066 20.4633 18.7303 20.5397 18.6348C20.6161 18.5393 20.6691 18.4273 20.6946 18.3077C20.7244 18.1907 20.7257 18.0683 20.6983 17.9507C20.671 17.8331 20.6158 17.7238 20.5375 17.632L16.326 12.2734",
    stroke: "#9B2C51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalIcon);
export default __webpack_public_path__ + "static/media/medal-icon.8586ee5f20a8d3d83ca2cfc9eb112ccb.svg";
export { ForwardRef as ReactComponent };